stellarCommerce.couponForm = {};

(function(window, document, $, app) {
	app.selectors = {
		couponWrapper: '.sc-coupon',
		couponLink: '.sc-coupon__prompt-link',
		couponForm: '.sc-coupon__form'
	};

	/**
	 * Handle the coupon link click.
	 *
	 * @param {Event} event The event object.
	 */
	app.handleCouponLinkClick = function(event) {
		event.preventDefault();

		const $wrapper = $(this).closest(app.selectors.couponWrapper);
		const $link = $(this);
		const $form = $wrapper.find(app.selectors.couponForm);

		$wrapper.toggleClass('sc-coupon--show');

		const isExpanded = $wrapper.hasClass('sc-coupon--show');
		$link.attr('aria-expanded', isExpanded);
		$form.attr('aria-hidden', !isExpanded);

		if (isExpanded) {
			$form.find('#coupon_code').focus();
		}
	};

	/**
	 * Initialize the coupon form.
	 *
	 * @param {Event} event The event object.
	 * @param {Object} bundle The bundle object.
	 */
	app.init = function() {
		$(document).on('click', app.selectors.couponLink, app.handleCouponLinkClick);
	};

	/**
	 * Set up the coupon form logic.
	 */
	$(function() {
		app.init();
	});
})(window, document, jQuery, stellarCommerce.couponForm);
